import { render, staticRenderFns } from "./informatica.vue?vue&type=template&id=5d0e6776&"
import script from "./informatica.vue?vue&type=script&lang=js&"
export * from "./informatica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CursosBannerIndex: require('/opt/buildhome/repo/components/Cursos/BannerIndex.vue').default,CursosComoFuncionam: require('/opt/buildhome/repo/components/Cursos/ComoFuncionam.vue').default,CursosLista: require('/opt/buildhome/repo/components/Cursos/Lista.vue').default,CursosOutrosCursos: require('/opt/buildhome/repo/components/Cursos/OutrosCursos.vue').default,CursosAgendarAula: require('/opt/buildhome/repo/components/Cursos/AgendarAula.vue').default,CursosDuvidas: require('/opt/buildhome/repo/components/Cursos/Duvidas.vue').default})
